// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__dFC5C","footer":"ModalError_footer__il0to"};